export enum OrderItemSortType {
  ALL = "ALL",
  INCENTIVE_DISCOUNT = "INCENTIVE_DISCOUNT", // 인센티브 할인 유무 - 높은 할인순으로 정렬
  DISCOUNT = "DISCOUNT", // 기본 할인 높은 기준으로 정렬
  LOW_PRICE = "LOW_PRICE",
  HIGH_PRICE = "HIGH_PRICE",
}

export const orderItemSortTypeDisplayNames = {
  [OrderItemSortType.ALL]: "전체",
  [OrderItemSortType.INCENTIVE_DISCOUNT]: "인센티브 할인순",
  [OrderItemSortType.DISCOUNT]: "할인 순",
  [OrderItemSortType.LOW_PRICE]: "낮은 가격순",
  [OrderItemSortType.HIGH_PRICE]: "높은 가격순",
};
